import { createVNode, mergeProps } from "vue";
export default {
  name: 'FilmIcon',
  props: {
    size: {
      type: String,
      default: '16',
      validator: s => !isNaN(s) || s.length >= 2 && !isNaN(s.slice(0, s.length - 1)) && s.slice(-1) === 'x'
    }
  },

  setup(props, ctx) {
    const size = props.size.slice(-1) === 'x' ? props.size.slice(0, props.size.length - 1) + 'em' : parseInt(props.size) + 'px';
    const attrs = { ...ctx.attrs
    };
    attrs.width = attrs.width || size;
    attrs.height = attrs.height || size;
    return () => createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "class": "feather feather-film"
    }, { ...attrs
    }), [createVNode("rect", {
      "x": "2",
      "y": "2",
      "width": "20",
      "height": "20",
      "rx": "2.18",
      "ry": "2.18"
    }), createVNode("line", {
      "x1": "7",
      "y1": "2",
      "x2": "7",
      "y2": "22"
    }), createVNode("line", {
      "x1": "17",
      "y1": "2",
      "x2": "17",
      "y2": "22"
    }), createVNode("line", {
      "x1": "2",
      "y1": "12",
      "x2": "22",
      "y2": "12"
    }), createVNode("line", {
      "x1": "2",
      "y1": "7",
      "x2": "7",
      "y2": "7"
    }), createVNode("line", {
      "x1": "2",
      "y1": "17",
      "x2": "7",
      "y2": "17"
    }), createVNode("line", {
      "x1": "17",
      "y1": "17",
      "x2": "22",
      "y2": "17"
    }), createVNode("line", {
      "x1": "17",
      "y1": "7",
      "x2": "22",
      "y2": "7"
    })]);
  }

};